import styled from "styled-components";
import { breakpoints } from "theme/themes";

const StyledScenarioIntro = styled.div`
  background-color: ${(props) => props.backgroundColor};
  position: relative;

  .background-image {
    width: 88%;
    display: flex;
    /* max-width: 750px; */

    @media ${breakpoints.large} {
      max-width: none;
      width:  ${(props) => props.backgroundImageWidth || "60%"};
      top: 0;
      left: 0;
      position: absolute;
    }

    @media ${breakpoints.xl} {
      width: ${(props) => props.backgroundImageWidth || "70%"};
    }

    > svg {
      width: 100%;
      height: 100%;
    }
  }

  .content {
    width: 100%;
    padding: 1rem;

    @media ${breakpoints.medium} {
      padding: 2rem;
    }

    @media ${breakpoints.large} {
      min-height: 100vh;
      max-height: 1080px;
      display: flex;
      justify-content: flex-end;
      padding-left: 0;
      padding: 3rem 2rem;
    }

    @media ${breakpoints.xl} {
      align-items: center;
    }

    @media ${breakpoints.xl4} {
      padding-right: 150px;
    }

    .content-wrapper {
      width: 100%;
      @media ${breakpoints.large} {
        margin-top: 4rem;
        width: 52%;
        max-width: 800px;
      }

      @media ${breakpoints.xl} {
        margin-top: 2rem;
        width: 45%;
        min-width: 500px;
      }
    }

    .bubble-talk {
      height: fit-content;
      font-family: ${({ theme }) => theme.fonts.fontMedium};
      font-size: 22px;
      margin-bottom: 4rem;
      width: 100% ;

      &:hover {
        filter: none;
      }

      @media ${breakpoints.xl} {
        font-size: 24px;
        padding: 48px 64px;
      }

      @media ${breakpoints.xl4} {
        font-size: 30px;
      }

      p:not(:last-of-type) {
        margin-bottom: 1rem;
      }

      .button-continue {
        margin-left: auto;
        &:hover {
          filter: brightness(1.15);
        }
      }
    }
  }
`;

export default StyledScenarioIntro;
